import { getClientCampaigns } from "../../../services/api/GoogleApi";

export const checkIfClientHasCampaigns = (clientResourceName, managerId, accessToken) => {
    return new Promise((resolve, reject) => {
        getClientCampaigns(clientResourceName, managerId, accessToken)
        .then((res) => {
            const clientCampaigns = res?.data?.data?.clientCampaigns;
            if ( clientCampaigns && clientCampaigns?.length > 0 ) resolve({hasCampaigns: true});
            else resolve({hasCampaigns: false});
        })
        .catch((err) => {
            console.error(err)
            reject(err)
        });
    })
}